// extracted by mini-css-extract-plugin
export default {"sliderCard":"SliderCard_sliderCard__VN21S","sliderCard_voteAverage":"SliderCard_sliderCard_voteAverage__5Q6u7","sliderCard_description":"SliderCard_sliderCard_description__7gqJY"};